export enum DataServices {
  ALL = '*',
  Access = 'access',
  ApiKeys = 'api-keys',
  Dashboard = 'dashboard',
  Investigator = 'investigator',
  Organizations = 'organizations',
  Policies = 'policies',
  HealthChecker = 'cgh',
}